export const version = "bytes/5.6.0";
//# sourceMappingURL=_version.js.map